import styled, { css } from 'styled-components/macro'

import { settings } from '../../styled/settings/index';
import { mixins } from '../../styled/mixins/index';

const {
  colors: { color, hexToRGBa },
  mediaqueries: { mobileDown, tabletLandscapeDown, tabletPortraitDown },
  sizing: { fontsize, spacingsize, radiussize },
  shadows: { buttonShadowDefault },
} = settings;

const {
  layout: { centered, centeredContent, pageSection, pageSectionInner },
  typography: { heading1, heading2, heading3, heroDescription },
} = mixins;

export const BookATourPageContainer = styled.div`
  /* not ideal but to offset padding from the main app container */
  margin-top: -1rem;
  background-color: ${color(`white`)};
  padding-top: ${spacingsize(5)};
`;

export const BookATourPageInnerContainer = styled.div`
  display: grid;
  grid-template-columns: 40fr 60fr;

  @media ${tabletPortraitDown} {
    grid-template-columns: 100fr;
    grid-template-rows: 30fr 70fr;
  }

  @media ${tabletPortraitDown} {
    display: block;
  }
`;

export const BookATourPageLeftColumn = styled.div`
  background-color: ${color(`black`)};
  grid-column-start: 1;
  grid-column-end: 2;

  @media ${tabletPortraitDown} {
    grid-column-start: 1;
    grid-column-end: 2;
    grid-row-start: 1;
    grid-row-end: 2;
  }
`;

export const BookATourPageLeftColumnInner = styled.div`
  height: 100vh;
  width: 100%;

  /* stylelint-disable comment-empty-line-before */
  ${(props) => (!props.hasPhoto) && css`
    display: flex;
    align-items: center;
  `}
  /* stylelint-enable */

  @media ${tabletPortraitDown} {
    height: auto;
  }
`;

export const BookATourPageRightColumn = styled.div`
  grid-column-start: 2;
  grid-column-end: 3;

  @media ${tabletPortraitDown} {
    grid-column-start: 1;
    grid-column-end: 2;
    grid-row-start: 2;
    grid-row-end: 3;
  }
`;

export const Photo = styled.img`
  width: 100%;
`;

export const LogoContainer = styled.div`
  padding: ${spacingsize(9)};
  display: table;
  margin: 0 auto;
`;

export const Logo = styled.img`
  margin: 0 auto;
  display: table;
  height: 10rem;

  @media ${tabletPortraitDown} {
    height: 6rem;
  }

  @media ${mobileDown} {
    height: 3rem;
  }
`;

export const LogoTitle = styled.h1`
  ${heading1}
  text-align: center;
  text-transform: uppercase;
  color: ${color(`white`)};
  margin-top: ${spacingsize(9)};
`;

export const LogoSubTitle = styled.h3`
  ${heading2}
  text-align: center;
  text-transform: uppercase;
  color: ${color(`black`)};
  margin-top: ${spacingsize(9)};
`;

export const LogoDescription = styled.p`
  ${centeredContent}
  ${heroDescription}
  color: ${color(`black`)};
  margin-top: ${spacingsize(9)};
  max-width: 50vw;

  @media ${tabletLandscapeDown} {
    max-width: 65vw;
  }

  @media ${tabletPortraitDown} {
    max-width: 80vw;
  }

  @media ${mobileDown} {
    max-width: 85vw;
  }
`;